import { authHeader, authUploadService } from 'services';
import { getUserToken } from 'util/auth';
import { Api } from './api/axios.service';

const FILE_DOWNLOAD_URL = `${process.env.REACT_APP_BASE_API_URL}/api/vet`;

const signUpVet = (vet: any) => {
  let formData = new FormData();
  const keys = Object.keys(vet);

  keys.forEach((key) => {
    if (vet[key].name) {
      formData.append(key, vet[key], vet[key].name);
    } else {
      formData.append(key, vet[key]);
    }
  });

  return Api.post('/vet', formData, { headers: authUploadService() }).then(
    (response) => response.data
  );
};

const updateVet = (vet: any) => {
  let formData = new FormData();
  const keys = Object.keys(vet);

  keys.forEach((key) => {
    switch (key) {
      case 'bankAccount':
        formData.append('bank', vet[key]['bank']);
        formData.append('agency', vet[key]['agency']);
        formData.append('checkingAccount', vet[key]['checkingAccount']);
        break;
      case 'idDoc':
        if (vet[key] instanceof File) {
          formData.append(key, vet[key]);
        }
        break;
      case 'counselorCard':
        if (vet[key] instanceof File) {
          formData.append(key, vet[key]);
        }
        break;
      default:
        formData.append(key, vet[key]);
        break;
    }
  });

  return Api.put(`/vet/${vet.cpf}`, formData, {
    headers: authUploadService(),
  }).then((response) => response);
};

const updateVetWorkedHours = (data: { hoursWorked: number }, cpf: string) =>
  Api.put(`/vet/worked-hours/${cpf}`, data, {
    headers: authHeader(),
  });

const getVetInfo = (cpf: string) => {
  return Api.get(`/vet/${cpf}`, {
    headers: authHeader(),
  });
};

/**
 * Get vet identification document by id
 *
 * @param {string} [vetId]
 * @return {*}  {string}
 */
const getIdentificationDocument = (vetId?: string): string => {
  if (!vetId) {
    return '';
  }

  return `${FILE_DOWNLOAD_URL}/document-download/${vetId}/?access_token=Bearer ${
    getUserToken().token
  }`;
};

/**
 * Get vet counselor card document by id
 *
 * @param {string} [vetId]
 * @return {*}  {string}
 */
const getCounselorCardDocument = (vetId?: string): string => {
  if (!vetId) {
    return '';
  }

  return `${FILE_DOWNLOAD_URL}/counselor-card-download/${vetId}/?access_token=Bearer ${
    getUserToken().token
  }`;
};

export const VetService = {
  signUpVet,
  updateVet,
  updateVetWorkedHours,
  getVetInfo,
  getIdentificationDocument,
  getCounselorCardDocument,
};
